import React from 'react';

import dateFormat from '@/utils/dateFormat';

import { User } from '@/types/user';

import Badge from '../badge/Badge';
import Profile from '../profile/Profile';

export type ProfileType = {
  name: User['name'];
  thumbImg?: string;
};

type Props = {
  profile: ProfileType;
  updateDate: string;
  isAuthor?: boolean;
};

export default function ReplyProfile({ profile, updateDate, isAuthor }: Props) {
  return (
    <div className="flex min-w-0 items-center gap-2">
      <Profile
        size="sm"
        className="h-[32px] w-[32px] flex-none"
        src={profile.thumbImg ?? '/images/admin/common/no-profile.svg'}
        alt="프로필 이미지"
      />
      <div className="flex min-w-0 items-center gap-2">
        <div className="flex min-w-0 gap-1">
          <div className="overflow-hidden text-ellipsis whitespace-nowrap text-[15px] font-bold leading-[150%]">
            {profile.name}
          </div>
          {isAuthor && <Badge variant="line">작성자</Badge>}
        </div>
        <p className="whitespace-nowrap text-xs font-normal leading-[150%] text-apps-coreGray03">
          {dateFormat(updateDate, 'YYYY-MM-DD')}
        </p>
      </div>
    </div>
  );
}
